import { combineReducers } from "redux";
import prerequisites from "./prerequisites";
import currentUser from "./currentUser";
import modalForm from "./modalForm";
import overview from "./overview";
import entities from "./entities";
import route from "./route";
import search from "./search";
import ui from "./ui";
import datepicker from "./datepicker";

const conductorReducer = combineReducers({
  prerequisites,
  currentUser,
  modalForm,
  overview,
  entities,
  search,
  route,
  ui,
  datepicker
});

export default conductorReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js